import React from 'react';
import PropTypes from 'prop-types';
import Pronunciation from '../pronunciation';
import UserTackProgressHeader from '../user_tack_progress_header';
import WordService from '../../services/word_service';

export default class Header extends React.Component {

  static propTypes = {
    wordText: PropTypes.string,
    pronunciationFile: PropTypes.string,
    partOfSpeech: PropTypes.string,
    mnemonicImageUrl: PropTypes.string,
    tackedBy: PropTypes.object,
    tacksCount: PropTypes.number,
    tackInterval: PropTypes.number,
    hasSubscription: PropTypes.bool
  }

  constructor(props) {
    super(props);
    this.state = {
      pollingForImage: false,
      polledImageUrl: null
    };
    this.pollingInterval = null;
  }

  componentDidMount() {
    this.startPollingIfNeeded();
  }

  componentDidUpdate(prevProps) {
    // If hasSubscription or wordText changed, restart polling logic
    if (prevProps.hasSubscription !== this.props.hasSubscription ||
      prevProps.wordText !== this.props.wordText ||
      prevProps.mnemonicImageUrl !== this.props.mnemonicImageUrl) {
      this.startPollingIfNeeded();
    }
  }

  componentWillUnmount() {
    this.stopPolling();
  }

  startPollingIfNeeded() {
    // Stop any existing polling
    this.stopPolling();

    // Check if we should start polling:
    // - User has subscription
    // - No mnemonic image URL exists yet (neither from props nor from polling)
    // - We have a word to poll for
    const shouldPoll = this.props.hasSubscription &&
      !this.props.mnemonicImageUrl &&
      !this.state.polledImageUrl &&
      this.props.wordText;

    if (shouldPoll) {
      this.setState({ pollingForImage: true });
      this.pollForMnemonicImage();
    }
  }

  stopPolling() {
    if (this.pollingInterval) {
      window.clearInterval(this.pollingInterval);
      this.pollingInterval = null;
    }
    this.setState({ pollingForImage: false });
  }

  pollForMnemonicImage() {
    // Poll every 3 seconds
    this.pollingInterval = window.setInterval(async () => {
      try {
        const wordData = await WordService.fetch(this.props.wordText, 'en');
        if (wordData.mnemonic_image_url) {
          this.setState({
            polledImageUrl: wordData.mnemonic_image_url,
            pollingForImage: false
          });
          this.stopPolling();
        }
      } catch (error) {
        console.error('Error polling for mnemonic image:', error);
        // Continue polling on error
      }
    }, 3000);
  }

  renderMnemonicImageOrSkeleton() {
    const imageUrl = this.props.mnemonicImageUrl || this.state.polledImageUrl;

    if (imageUrl) {
      return (
        <img
          src={imageUrl}
          alt={`Mnemonic for ${this.props.wordText}`}
          style={{
            width: '100px',
            height: '100px',
            objectFit: 'cover',
            borderRadius: '8px',
            marginLeft: '20px'
          }}
        />
      );
    } else if (this.state.pollingForImage) {
      return (
        <div
          style={{
            width: '100px',
            height: '100px',
            backgroundColor: '#f0f0f0',
            borderRadius: '8px',
            marginLeft: '20px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
            overflow: 'hidden'
          }}
        >
          {/* Loading skeleton with shimmer effect */}
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: '-100%',
              width: '100%',
              height: '100%',
              background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.6), transparent)',
              animation: 'shimmer 1.5s infinite'
            }}
          />
          <style>
            {`
              @keyframes shimmer {
                0% { left: -100%; }
                100% { left: 100%; }
              }
            `}
          </style>
        </div>
      );
    }

    return null;
  }

  render() {
    return (
      <div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <div>
            <h2 className='word-title' style={{ wordBreak: 'break-word' }}>
              {this.props.wordText}
              <Pronunciation wordText={this.props.wordText} pronunciationFile={this.props.pronunciationFile} />
            </h2>
            <div className='pull-in-5 part-of-speech'>
              <i>{this.props.partOfSpeech}</i>
            </div>
          </div>
          {this.renderMnemonicImageOrSkeleton()}
        </div>
        {this.renderDelimiter()}
      </div>
    );
  }

  renderDelimiter() {
    if (this.props.tackInterval && this.props.tackInterval > 0) {
      return (
        <div style={{ marginTop: 10, marginBottom: 35 }}>
          <UserTackProgressHeader currentInterval={this.props.tackInterval}></UserTackProgressHeader>
        </div>
      );
    } else {
      return (
        <div className='word-title-underline'></div>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/word/header.jsx